<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<div class="secNav devList">
				<h3 class="relative-box">
					<strong>最新版本</strong>
				</h3>
				<p class="ml40 mt30" v-if="!latestDev.length">暂无最新版本设备</p>
				<ul>
					<li v-for="(item,index) in latestDev">
						<span><i class="fa fa-tachometer"></i></span>
			            <a v-text="item.device_name" href="javascript:void(0);"></a>
			          </li>
				</ul>
			</div>
			<div class="secNav devList">
				<h3 class="relative-box">
					<strong>可更新<span>（设备更新过程中不可断电，否则会导致设备损坏不可用。）</span></strong>
				</h3>
				<p class="ml40 mt30" v-if="!updateDev.length">暂无可更新设备</p>
				<ul>
					<li @click="showVersion(item.id)" v-for="(item,index) in updateDev">
						<span><i class="fa fa-tachometer"></i></span>
			            <a v-text="item.device_name" href="javascript:void(0);"></a>
			          </li>
				</ul>
			</div>
			
		</div>
		<el-dialog title="版本信息" :visible.sync="dialogVisible" width="400px" >
		    <el-form>
	        	<el-form-item label="设备名称：" label-width="100px">
			    	<span v-text="devDetail.device_name"></span>
			    </el-form-item>
			    <el-form-item label="MAC地址：" label-width="100px">
			    	<span v-text="devDetail.mac_address"></span>
			    </el-form-item>
			    <el-form-item label="当前版本：" label-width="100px">
			    	<span v-text="devDetail.version"></span>
			    </el-form-item>
			    <el-form-item label="最新版本：" label-width="100px">
			    	<span v-text="devDetail.new_version"></span>
			    </el-form-item>
			    <el-progress v-if="ifUpdate" :percentage="percentage"></el-progress>
	        </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="cancelDia()">取消</el-button>
			    <el-button v-if="!ifUpdate" type="primary" @click="updateVersion()">升级</el-button>
			    <el-button v-if="ifUpdate" type="default">升级</el-button>
			  </div>
		</el-dialog>
	</div>
</template>
<script>
export default {
  name: 'app',
  data(){
    return {
    	latestDev:[],
    	updateDev:[],
    	devDetail:{},
    	dialogVisible:false,
    	ifUpdate:false,
    	percentage:1,
    	
    }
  },
  mounted(){
    this.$nextTick(function(){
    	this.getDevList();
  	})
  },

  methods: {
	getDevList(){
//		获取最新版本
		let valiCodeParams={
			uid:this.getCookie('uid'),
	  		time:Date.parse( new Date()),
	  		type:0,
	  		terminalId:4
  		};
  		this.sign(valiCodeParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/UpgradeList/UpgradeList",this.$qs.stringify(valiCodeParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.latestDev = res.data.data || [];
        		
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
        	}else{
        		this.$message.error(res.data.msg);
        	}
  		});
//		获取可更新版本
  		let valiCodeParams2={
			uid:this.getCookie('uid'),
	  		time:Date.parse( new Date()),
	  		type:1,
	  		terminalId:4
  		};
  		this.sign(valiCodeParams2);
  		this.$ajax.post(this.$store.state.domain+"/Home/UpgradeList/UpgradeList",this.$qs.stringify(valiCodeParams2),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.updateDev = res.data.data || [];
        		
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
        	}else{
        		this.$message.error(res.data.msg);
        	}
  		});
	},
	cancelDia(){
		this.dialogVisible = false;
	},
	showVersion(devId){
		this.ifUpdate = false;
		let versionParam={
			uid:this.getCookie('uid'),
	  		time:Date.parse( new Date()),
	  		device_id:devId,
	  		terminalId:4
  		};
  		this.sign(versionParam);
  		this.$ajax.post(this.$store.state.domain+"/Home/UpgradeDesc/UpgradeDesc",this.$qs.stringify(versionParam),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.dialogVisible = true;
        		this.devDetail = res.data.data
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
        	}else{
        		this.$message.error(res.data.msg);
        	}
  		});
	},
	updateVersion(){
		this.percentage = 1;
		let versionParam={
			uid:this.getCookie('uid'),
	  		time:Date.parse( new Date()),
	  		device_id:this.devDetail.id,
	  		terminalId:4
  		};
  		this.sign(versionParam);
  		this.$ajax.post(this.$store.state.domain+"/Home/Upgrade/Upgrade",this.$qs.stringify(versionParam),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.dialogVisible = true;
        		this.ifUpdate = true;
        		this.updateProgress();
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
        	}else{
        		this.$message.error(res.data.msg);
        	}
  		});
  		
		
	},
	updateProgress(){
		let versionParam={
			uid:this.getCookie('uid'),
	  		time:Date.parse( new Date()),
	  		mac_address:this.devDetail.mac_address,
	  		terminalId:4
  		};
  		this.sign(versionParam);
		const timer = setInterval(() => {
			this.$ajax.post(this.$store.state.domain+"/Home/UpgradePercent/UpgradePercent",this.$qs.stringify(versionParam),{
	            emulateJSON: true
	        }).then(res=>{
	        	if(res.data.status==1){
	        		this.percentage = parseInt(res.data.data.percent) || 1;
	        		if(this.percentage>=100){
						clearInterval(timer);
						this.dialogVisible = false;
						if(this.percentage==101){
							this.getDevList();
							this.$message.success("固件升级成功！",2000);
						}else{
							this.$message.error("固件升级失败！",2000);
						} 
					}
	        	}else if(res.data.code==10008){
				      this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
	        	}else{
	        		this.$message.error(res.data.msg);
	        	}
	  		});
		}, 5000);
		
		
	},
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/device/firewareUpdate.vue